<template>
  <div>
    <div class="info_warp">
      <div class="info_item">套餐信息</div>
      <div class="info_item">
        <div class="info_item_row">
          <span class="info_label">套餐名称:</span>
          <span>（4人豪华套房+早餐4位+温泉4位+大餐庙会4位+单车券+烟花券+游戏券）（4人豪华套房+早餐4位+温泉4位+大餐庙会4位+单车券+烟花券+游戏券）（1张1.8中式大床+2张95公分榻榻米铺在客厅）</span>
        </div>
      </div>
      <div class="info_item">
        <div class="info_item_row">
          <span class="info_label">入住日期:</span>
          <span>
            <el-date-picker
              v-model="value1"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </span>
          <span>离店2017-10-13 13:00前</span>
        </div>
        <div class="info_item_row">
          <span class="info_label">数量:</span>
          <span>
            <el-date-picker
              v-model="value1"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </span>
          <span>离店2017-10-13 13:00前</span>
        </div>
      </div>

    </div>

    <div class="info_warp">
      <div class="info_item">预订人</div>
      <div class="info_item">
        <div class="info_item_row">
          <el-form
            :model="checkInPeopleForm"
            label-width="100px"
            style="width:1000px;"
          >
            <el-form-item
              label="姓名"
              prop="name"
              style="width: 100%"
              :rules="[
                { required: true, message: '姓名不能为空'},
              ]"
            >
              <el-input
                type="name"
                v-model.number="checkInPeopleForm.name"
                style="width: 200px"
                autocomplete="off"
              ></el-input>
              <span class="extra_tip">请填写与身份证姓名相同的入住人信息</span>
            </el-form-item>
            <el-form-item
              label="手机"
              prop="phone"
              :rules="[
                { required: true, message: '手机不能为空'},
              ]"
            >
              <el-input
                type="name"
                v-model.number="checkInPeopleForm.phone"
                style="width: 200px"
                autocomplete="off"
              ></el-input>
              <span class="extra_tip">此手机号为接收短信所用,作为订购与取票凭证,请准确填写。</span>
            </el-form-item>
            <el-form-item
              label="验证码"
              prop="verification"
            >
              <el-input
                type="name"
                v-model.number="checkInPeopleForm.verification"
                style="width: 200px"
                autocomplete="off"
              ></el-input>
              <span class="extra_tip"><el-button type="success">发送验证码</el-button></span>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: '2019-4-3',
      checkInPeopleForm: {
        name: '',
        phone: '',
        verification:''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$border_bottom: 2px dotted #ddd;
$goldColor: gold;
.extra_tip {
  margin-left: 10px !important;
  font-size: 14px;
  color: #777;
}
.info_warp {
  width: 100%;
  min-height: 100px;
  padding: 10px 20px;
  border: 1px solid $goldColor;
  font-size: 18px;
  text-align: left;
  margin: 10px 0;
  .info_item {
    margin: 10px 0;
    padding: 10px 0;
    border-bottom: $border_bottom;
    display: flex;
    flex-direction: column;
    .info_item_row {
      display: flex;
      align-items: center;
      padding: 5px 0;
      .info_label {
        font-size: 16px;
        font-weight: 600;
        min-width: 100px;
      }
      span {
        margin: 0 5px;
      }
    }
  }
}
</style>
